export default __webpack_public_path__ + "static/media/review3.beb6d455.mp4";